<template>

<com-item name="game.locations" :is-list="true" :has-more="data.locationsTotal > 5" v-on:more="onMore" :size="size" :is-empty="!active" :loading="loading" title="Locations">

	<template v-slot:about>

		<p>Where {{ you }} played this game.</p>

	</template>

	<template v-slot:stats>

		<app-thing v-for="(item, index) in locations" :nolink="true" :item="item" :key="index" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	computed: {

		loading: function() {

			return this.fetching === 'all'

		},

		data: function() {

			return this.$store.getters['page/insights/game/plays']

		},

		locations: function() {

			return (this.data && this.data.locations) ? this.data.locations : []

		},

		active: function() {

			return this.locations.length && !this.loading

		}

	},

	methods: {

		onMore: function() {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsGameLocations',
				id: parseInt(this.$route.params.game) || 0
			})

		}

	}

}

</script>

<style scoped>

</style>
